module.exports = __webpack_public_path__ + "img/eff02Big1pc.d14da77e.png";